<footer id="footer" class="footer" role="contentinfo">
    <div class="row is-multiline align-items--center reset-margin--bottom">
        <div class="column is-10-mobile is-12-tablet is-7-desktop">
            <div *ngTemplateOutlet="legal"></div>
        </div>
        <div class="column is-10-mobile is-12-tablet is-5-desktop is-flex no-text-link-section">
            <div class="row is-gapless">
                <div class="column is-flex is-flex-wrap-wrap is-vcentered">
                    @if (!authService.isLoggedIn()) {
                        <span class="footer__link language-switch">
                            <app-language-switch position="above"></app-language-switch>
                        </span>
                    }
                    <span class="footer__link footer__copyright"> &copy; {{ currentYear }} </span>
                    <a href="https://www.riege.com" class="footer__logo footer__link" target="_blank">
                        <img
                            i18n-alt="@@footer-logo-alt"
                            alt="Riege Software Logo, back to homepage"
                            src="assets/images/logo-riege-footer.svg" />
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- TEMPLATE: Legal Links (shared) -->
    <ng-template #legal>
        <div class="footer__link">
            <a href="{{ linkImprint }}" target="_blank" i18n="@@footer-link-imprint">Imprint</a>
        </div>
        <div class="footer__link">
            <a routerLink="/privacy-policy" i18n="@@footer-link-privacy">Privacy</a>
        </div>
        <div class="footer__link">
            <a routerLink="/accessibility-statement" i18n="@@footer-link-accessibility">Accessibility</a>
        </div>
        <div class="footer__link">
            <a href="{{ linkTerms }}" target="_blank" i18n="@@footer-link-terms">Terms</a>
        </div>
        <div class="footer__link">
            <a href="{{ linkTermsUS }}" target="_blank" i18n="@@footer-link-terms-us">Terms US</a>
        </div>
        @if (showCookieConsent) {
            <div class="footer__link">
                <a href="#" (click)="manageCookies($event)" i18n="@@footer-link-consent">Manage cookies</a>
            </div>
        }
    </ng-template>
</footer>
